import React, { useState, useEffect ,useRef, useCallback } from 'react';
import  RoleList  from '../components/role-list-view';
import { useDispatch,  useSelector } from 'react-redux';
import {
  roleManagementIsLoading,
  roleManagementRoles,
  roleManagementRolesRequestGet,
  roleManagementPost,
  socialServiceRequestGet,
  roleManagementRolePatch,
  roleManagementRoleApproversPut,
  roleManagementRoleApproversGet,
  getApproversIsLoading,
  roleManagementRoleApproversDelete
} from 'modules/role-management-module';
import { getAPIError, stopEvent } from 'lib/utility-functions';
import { uiShowToastrMessage } from 'modules/ui-module';
import { isEmpty, isEqual , sortBy } from 'lodash';

export const RoleListContainer = () => {
  const dispatch = useDispatch();
  const originalState = { id: '', description: '', approvers: [], active: true };
  const externalProps = useSelector(getValuesFromStore);
  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  const [showAddRoleDialog, setShowAddRoleDialog] = useState(false);
  const [openEditRoleDialog,setOpenEditRoleDialog] = useState(false);
  const [role, setRole] = useState(originalState);
  const [errors, setErrors] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [ownersList, setOwnersList] = useState([]);
  const [personIconClicked, setPersonIconClicked] = useState(false);
  const [autoCompletelist , setAutoCompletelist] = useState([]);
  const autoCompleteRef = useRef(null);
  const [textEmail,setEmail] = useState('');
  const [roleList, setRoleList] = useState(externalProps.roles);
  const [sortDirection, setSortDirection] = useState(null);
  const mounted = useRef();


  const onClickAddRole = () => {
    setRole(originalState);
    setShowAddRoleDialog(true);
  };

  const getApproversList = (id) => {
    dispatch(roleManagementRoleApproversGet(id)).
    then(
      (response) => {
        setOwnersList(response.payload.map((item) => item.email));
        return response.payload.map((item) => item.email);
      }
    );
  };

  const editOnClick = (id) =>{

    dispatch(roleManagementRoleApproversGet(id)).
      then((response) => {
        let openedRole = externalProps.roles.find((data) => data.id === id);
        const approversEmails = response.payload.map((item) => item.email);
        setOwnersList(approversEmails);
        const updatedRole = {
          ...openedRole,
          approvers: approversEmails || []
        };
        setRole(updatedRole);
        setOpenEditRoleDialog(true);
      });
  };

  const closeEditModel = () =>{
    setOpenEditRoleDialog(false);
    setShowAddRoleDialog(false);
    setRole(originalState);
    setEnableSubmit(false);
    setOwnersList([]);
    setAutoCompletelist([]);
    if(autoCompleteRef.current) {
      autoCompleteRef.current.value = '';
      autoCompleteRef.current.clear();
    }
  };

  const personIconClick = (id) => {
    setPersonIconClicked(true);
    getApproversList(id);
  };

  const onSort = () => {
    const columnKey = 'id';
    const newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    setSortDirection(newSortDirection);

    const sortedData = [...externalProps.roles].sort((a, b) => {
      return newSortDirection === 'asc'
      ? a[columnKey].localeCompare(b[columnKey])
      : b[columnKey].localeCompare(a[columnKey]);
    });
    setRoleList(sortedData);
  };

  const displayToastrMessage = (toastrType, toastrMessageId, toastrParams = null) => {
    dispatch(uiShowToastrMessage(toastrType, toastrMessageId, toastrParams));
  };

  const handleXHRResult = (success, messageId, toastrParams = null) => {
    const toastrType = success ? 'success' : 'error';
    displayToastrMessage(toastrType, messageId);
  };

  const validateUserInput = (field, value, onBlurCheck) => {
    let errorText = '';
    const foundErrors = { ...errors };

    if (foundErrors[field]) {
      delete foundErrors[field];
    }
    if(field === 'id'){
      const feildValue = value ;
      const alreadyPresentName = externalProps.roles.some(role => role.id.trim() == feildValue.trim());
      if (alreadyPresentName) {
        errorText = 'role-management.role.already.exists';
      }
    }
    if (field=== 'id' && !errorText.length && /[^a-z0-9_]/i.test(value)) {
      errorText = 'role-management.role.id.invalid';
    }
    if (field === 'description' && value.length > 500) {
      errorText = 'client-edit.validation.description-exceeds-max-length';
    }
    if(field === 'approvers' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)){
      errorText = 'role-management.role.owner.invalid';
    }
    if (errorText.length) {
      foundErrors[field] = errorText;
      setEnableSubmit(false);
    }
    setErrors(foundErrors);
    return !errorText.length;
  };

  const updateRoleState = (e) => {
    stopEvent(e);
    setErrors({});

    const field = e.target && e.target.id.split('-')[0];
    const value = e.target && e.target.value;

    setRole(prevRole => {
      const foundRole = { ...prevRole };

      if (field === 'active') {
        foundRole[field] = e.target.checked;
      }
      else if(field === 'id' && validateUserInput(field, value)){
        foundRole[field] = value;
      }
      else if(field === 'approvers'){
        const text = e.detail.value;
        if(text && text.length > 0){
          setEmail(text);
          dispatch(socialServiceRequestGet(text)).
          then(
            (response) => {
              setAutoCompletelist(response.payload?.users?.map((item) => item.email));
            });
        }
        //handles if same email id used multiple times in the autocomplete
        foundRole[field] = !!ownersList.length ? [...new Set([...(e.detail?.selectedOptions || []).map(option => option.value)])] :
        [...new Set([...(foundRole[field] || []),...(e.detail?.selectedOptions || []).map(option => option.value)])];
      }
      else if (field === "description" && validateUserInput(field, value)){
        foundRole[field] = value;
      }

      return foundRole;
    });
    return true;
  };

  const onSubmit = async(e) => {
    stopEvent(e);
    let originalRole = (role && role.id) ? externalProps.roles.find((data) => data.id === role.id) : null;
    setEnableSubmit(false);
    if(openEditRoleDialog){
      setOpenEditRoleDialog(false);
      const newApprovers = role.approvers?.filter((approver) => !ownersList.includes(approver.trim()));
      const deletedApprovers = ownersList.filter((approver) => !role.approvers?.includes(approver.trim()));

      if(newApprovers && newApprovers.length > 0){
        for(const newApprover of  newApprovers){
          dispatch(roleManagementRoleApproversPut(role.id, newApprover,newApprover)).
          then(
            () => {
              handleXHRResult(true, 'role-management.role.owners.add.success');
            },
            (error) => {
              handleXHRResult(false, 'role-management.role.owners.add.failed');
            });
          await sleep(1000);
          }
      }
      if(deletedApprovers && deletedApprovers.length > 0){
        for(const approver of  deletedApprovers){
          dispatch(roleManagementRoleApproversDelete(role.id, approver, approver)).then(
            () => {
              handleXHRResult(true, 'role-management.role.owners.delete.success');
            },
            (error) => {
              handleXHRResult(false, 'role-management.role.owners.delete.failed');
            });
          await sleep(1000);
        }
      }
      if((!!role && !!originalRole) && (role.active !== originalRole.active || role.description?.trim() !== originalRole.description?.trim())){
        // Don't include approvers in patch - they're handled separately above
        const { approvers, ...dataToSave } = role;
        dispatch(roleManagementRolePatch(role.id,dataToSave)).
          then(
            () => {
              handleXHRResult(true, 'role-management.role.edit.success');
              dispatch(roleManagementRolesRequestGet());
            },
            (error) => {
              handleXHRResult(false, 'role-management.role.edit.failed');
            },
          );
      }
    }
    else{
      const approvers = role.approvers;
      delete role.approvers;
      dispatch(roleManagementPost(role))
        .then(
          async () => {
            handleXHRResult(true, 'role-management.role.create.success');
            dispatch(roleManagementRolesRequestGet());
            setShowAddRoleDialog(false);
            if (approvers && approvers.length > 0) {
              for(const approver of approvers){
                dispatch(roleManagementRoleApproversPut(role.id, approver,approver)).
                then(
                  () => {
                    setShowAddRoleDialog(false);
                  },
                  (error) => {
                    handleXHRResult(false, 'role-management.role.owners.add.failed');
                    setShowAddRoleDialog(false);
                  });
                await sleep(1000);
              }
            }
          },
          (error) => {
            const errorObj = getAPIError(error);
            const errorCode = errorObj && errorObj.length === 1 ? errorObj[0].code : '';
            if(errorCode){
              handleXHRResult(false, 'role-management.role.add.failed');
            }
            setShowAddRoleDialog(false);
          },
        );
    }
    setRole(originalState);
    setOwnersList([]);
    setAutoCompletelist([]);
    if(autoCompleteRef.current) {
      autoCompleteRef.current.value = '';
      autoCompleteRef.current.clear();
    }
  };

  const onClickAddOwner = (e) => {
    stopEvent(e);
    if (textEmail && textEmail.trim() && validateUserInput('approvers', textEmail.trim())) {
      const foundRole = { ...role };
      const currentApprovers = foundRole.approvers || [];
      if (!currentApprovers.includes(textEmail)) {
        foundRole.approvers = [...new Set([...currentApprovers, textEmail])];
        setRole(foundRole);
        if(autoCompleteRef.current) {
          autoCompleteRef.current.value = '';
          setEmail('');
        }
      }
    }
  };

  const popOverChange = () =>{
    if(personIconClicked){
      setPersonIconClicked(false);
      setOwnersList([]);
    }
  };

  const updateEditCTA = useCallback(async() => {
    let originalRole = (role && role.id) ? externalProps.roles.find((data) => data.id === role.id) : null;
    if(showAddRoleDialog && isEmpty(errors) && role.id){
      setEnableSubmit(true);
    }
    // For edit dialog
    else if(openEditRoleDialog && originalRole){
      if (((role.active !== originalRole.active) ||
        (role.description?.trim() !== originalRole.description?.trim()) || !isEqual(sortBy(role.approvers), sortBy(ownersList))) &&
      isEmpty(errors)) {
        setEnableSubmit(true);
      }
      else {
        setEnableSubmit(false);
      }
    }
    // Default case - disable submit
    else {
      setEnableSubmit(false);
    }
  },[errors,externalProps.roles,role,ownersList,showAddRoleDialog,openEditRoleDialog]);

  useEffect(() => {
    if (!mounted.current) {
      dispatch(roleManagementRolesRequestGet());
      mounted.current = true;
    }
    else {
      updateEditCTA();
    }
  }, [dispatch,updateEditCTA,openEditRoleDialog,ownersList]);

  return (
    <RoleList
      isloading={externalProps?.isloading}
      getApproversIsLoading={externalProps?.approversIsLoading}
      onClickAddRole={onClickAddRole}
      showAddRoleDialog={showAddRoleDialog}
      roles={roleList.length > 0 ? roleList : externalProps.roles}
      editOnClick={editOnClick}
      openEditRoleDialog={openEditRoleDialog}
      closeEditModel={closeEditModel}
      onSubmit={onSubmit}
      onChange={updateRoleState}
      role={role}
      validateUserInput={validateUserInput}
      errors={errors}
      enableSubmit={enableSubmit}
      autocompleteList={autoCompletelist}
      personIconClick={personIconClick}
      ownersList={ownersList}
      personIconClicked={personIconClicked}
      popOverChange={popOverChange}
      autoCompleteRef={autoCompleteRef}
      onClickAddOwner={onClickAddOwner}
      onSort={onSort}
      sortDirection={sortDirection}
      />
  );
};

const getValuesFromStore = (state) =>{
  return {
    isloading: roleManagementIsLoading(state),
    roles: roleManagementRoles(state),
    approversIsLoading: getApproversIsLoading(state),
   };
};

export default RoleListContainer;
